import { isNil } from "lodash/fp"
import { inspect } from "./inspect"
import { getCustomHeaders } from "../Admin/functions"
import { httpRequest } from "../../functions/common"
import log from "loglevel"

const env = process.env['REACT_APP_ENV'] ?? 'dev'
// istanbul ignore next
log.setLevel((process.env['LOG_LEVEL'] as log.LogLevelDesc) ?? log.levels.DEBUG)

const baseName = 'miraiz-connect.jp'
const zoneName = `${{ prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
    }${baseName}`
const domainName = `api${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
    }.tsunagu-series.${zoneName}`

export const doUpload = async (file: File): Promise<boolean> => {
    const customHeaders = getCustomHeaders()
    if (isNil(customHeaders)) {
        return false
    }
    const data = new TextDecoder('shift-jis').decode(await file.arrayBuffer())
    log.debug(`[functions.doUpload]`, data)
    const result: {
        status: number,
        data: { success: boolean }
    } | undefined = await httpRequest('POST',
        `https://${domainName}/v1/admin/upload`,
        {
            file: data
        },
        {
            Authorization: customHeaders.get('Authorization')
        }
    )
    if (isNil(result)) {
        return false
    }
    console.log(`[functions.doUpload] ${inspect({ data: result.data })}`)
    return result.data.success
}

// export const doDownload = async (
//     memberId: string,
//     sub: string,
//     fileName: string
// ): Promise<any> => {
//     const subHash = await createHash('SHA-256', sub)
//     const result = await axios.get(
//         `https://${domainName}/v1/users/download/${memberId}`,
//         {
//             headers: {
//                 Authorization: `${memberId}.${subHash}`
//             }
//         }
//     )
//     const buffer = Buffer.from(result.data, 'base64')
//     console.log(`[functions.doDownload] ${inspect({ result })}`)
//     const url = window.URL.createObjectURL(new Blob([buffer]))
//     const a = document.createElement('a')
//     a.href = url
//     a.download = fileName
//     a.click()
//     a.remove()
//     return result.data
// }

// export const doTemplateDownload = async (
//     memberId: string,
//     sub: string
// ): Promise<any> => {
//     const subHash = await createHash('SHA-256', sub)
//     const result = await axios.get(
//         `https://${domainName}/v1/users/download/template`,
//         {
//             headers: {
//                 Authorization: `${memberId}.${subHash}`
//             }
//         }
//     )
//     const buffer = Buffer.from(result.data, 'base64')
//     console.log(`[functions.doDownload] ${inspect({ result })}`)
//     const url = window.URL.createObjectURL(new Blob([buffer]))
//     const a = document.createElement('a')
//     a.href = url
//     a.download = "EmployeeRegistForm.xlsx"
//     a.click()
//     a.remove()
//     return result.data
// }
